module.exports = __webpack_public_path__ + "img/gpay_white.52746f68.svg";